import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Player, Controls } from '@lottiefiles/react-lottie-player';

import { TbEngine } from 'react-icons/tb';
import { ClassContainer } from './styles';
import { useToast } from '../../../../../../hooks/toast';
import Cards from './dataTools';
import CardsModal from '../../../../../../components/CardsModal';

const WhatIsLEGO: React.FC = () => {
  const { t } = useTranslation();

  const { addToast } = useToast();

  const [showNextButton, setShowNextButton] = useState(false);

  useEffect(() => {
    if (showNextButton === true) {
      addToast({
        type: 'success',
        label: t("Now we're talking!"),
        description: t("Click on the 'next' button to continue!"),
      });
    }
  }, [addToast, showNextButton, t]);

  return (
    <ClassContainer showNextButton={showNextButton}>
      <h1>{t('Manual Tools')}</h1>
      <Player
        autoplay
        loop
        src="https://learnfirst-bucket.s3.amazonaws.com/frc/tools.json"
        style={{ height: '250px', width: '250px', margin: '1rem 0' }}
      >
        <Controls visible={false} />
      </Player>
      <p>
        {t(
          'Besides the tools presented in the electrical module, which are also used in mechanics, we will get to know some others specific to the field of mechanics.',
        )}
      </p>
      <p className="modalStartText">{t('Click the button below to start:')}</p>
      <CardsModal
        Icon={TbEngine}
        bgColor="#6cd0e0"
        propBorderColor="#c6eef5"
        setShowNextButton={setShowNextButton}
        cards={Cards}
      />
    </ClassContainer>
  );
};

export default WhatIsLEGO;
